const Resources = {

    table_headers: [
        {
            text:   'Description',
            align:  'start',
            value:  'description'
        },
        { 
            text:   'Worksheet',
            value:  'worksheet'
        },
        { 
            text:   'Minutes',
            value:  'minutes'
        },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Census',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Worksheets',
            href:   '/census-worksheets',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;